import toast from "react-hot-toast";

const toastBaseStyle = {
    borderRadius: "10px",
    color: "#fff",
    fontSize: "30px"
};

export function HotToastSucess(msg?: string) {
    toast(msg ?? "Sucesso", {
        icon: "✔",
        style: {
            ...toastBaseStyle,
            background: "#81c784"
        }
    });
}

export function HotToastError(msg?: string) {
    toast.error(msg ?? "Erro", {
        icon: "❌",
        style: {
            ...toastBaseStyle,
            background: "#e57373"
        }
    });
}

export function HotToastWarning(msg?: string) {
    toast(msg ?? "Aviso", {
        icon: "⚠",
        style: {
            ...toastBaseStyle,
            background: "#ffb74d"
        }
    });
}
